import { BaseModel } from '../base-model';

export interface IAppointmentType {
  AbbrCA?: string;
  AbbrDE?: string;
  AbbrEN?: string;
  AbbrFR?: string;
  AbbrNL?: string;
  AbbrSP?: string;
  AgendaTypeIconUrl?: string;
  Color?: number;
  Comment?: string;
  Cost?: number;
  DefaultStatus?: number;
  Duration?: number;
  Icon?: number;
  Id?: number;
  IsVisitType?: boolean;
  MessageForActualTenant?: number;
  MessageForOwner?: number;
  MessageForVisitor?: number;
  Name?: string;
  NameCA?: string;
  NameDE?: string;
  NameEN?: string;
  NameFR?: string;
  NameNL?: string;
  NameSP?: string;
  Order?: number;
  Private?: boolean;
  TreatAsCancelled?: boolean;
  AppointmentPlaceType?: string;
  MainType?: number | 0;
}

export class AppointmentType extends BaseModel<IAppointmentType> {
  AbbrCA?: string;
  AbbrDE?: string;
  AbbrEN?: string;
  AbbrFR?: string;
  AbbrNL?: string;
  AbbrSP?: string;
  AgendaTypeIconUrl?: string;
  Color?: number;
  Comment?: string;
  Cost?: number;
  DefaultStatus?: number;
  Duration?: number;
  Icon?: number;
  Id?: number;
  IsVisitType?: boolean;
  MessageForActualTenant?: number;
  MessageForOwner?: number;
  MessageForVisitor?: number;
  Name?: string;
  NameCA?: string;
  NameDE?: string;
  NameEN?: string;
  NameFR?: string;
  NameNL?: string;
  NameSP?: string;
  Order?: number;
  Private?: boolean;
  TreatAsCancelled?: boolean;
  AppointmentPlaceType?: string;
  MainType?: number;
  /**
   *
   */
  constructor(options?: { [key: string]: any }) {
    super(options);
  }
}